module.exports = __webpack_public_path__ + "img/20190815112658564.e1f9c028.png";